import { dispatch } from '../store';
import { LOADED_USERS, LOADING_USERS } from './constants';
import userStore from './index';
import db from 'db';

export async function fetchUsers() {
  if (!userStore.loaded && !userStore.loading) {
    dispatch(LOADING_USERS);
    const userDocs = await db.users.fetch();
    dispatch(LOADED_USERS, userDocs.map(u => u.data()));
  }
}
